export const RECEPCION_DOCUMENTO_ACCEPT = '.pdf,.png,.jpg,.jpeg';
export const RECEPCION_DOCUMENTO_MAX_SIZE_BYTES = 50 * 1024 * 1024;

const RECEPCION_DOCUMENTO_ALLOWED_EXTENSIONS = {
  pdf: 'pdf',
  png: 'png',
  jpg: 'jpeg',
  jpeg: 'jpeg',
} as const;

const startsWithBytes = (bytes: Uint8Array, signature: number[]) => (
  signature.every((value, index) => bytes[index] === value)
);

const detectRecepcionDocumentoType = async (file: File): Promise<string | null> => {
  const bytes = new Uint8Array(await file.slice(0, 16).arrayBuffer());

  if (startsWithBytes(bytes, [0x25, 0x50, 0x44, 0x46, 0x2d])) {
    return 'pdf';
  }

  if (startsWithBytes(bytes, [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a])) {
    return 'png';
  }

  if (startsWithBytes(bytes, [0xff, 0xd8, 0xff])) {
    return 'jpeg';
  }

  return null;
};

export const validateRecepcionDocumentoFile = async (file: File): Promise<string | null> => {
  if (file.size > RECEPCION_DOCUMENTO_MAX_SIZE_BYTES) {
    return 'El archivo no debe superar los 50 MB';
  }

  const extension = file.name.split('.').pop()?.toLowerCase() || '';
  const expectedType = RECEPCION_DOCUMENTO_ALLOWED_EXTENSIONS[
    extension as keyof typeof RECEPCION_DOCUMENTO_ALLOWED_EXTENSIONS
  ];

  if (!expectedType) {
    return 'Solo se permiten archivos PDF, PNG, JPG o JPEG';
  }

  const detectedType = await detectRecepcionDocumentoType(file);
  if (detectedType !== expectedType) {
    return 'El contenido del archivo no coincide con el formato seleccionado';
  }

  return null;
};
